import { SubformProps } from "."
import ReviewApplication from './review-application'
import { SubmitLoanApplication } from './submit-loan-application'
import { AwaitingContract } from './awaiting-contract'

export const SubmitApplication = (props: SubformProps) => {
  const { formData } = props

  return <div className="submit-application">
    <ReviewApplication {...props} />
    {!formData.contractDoc ? <AwaitingContract {...props} /> : <>
      <h2 className="mt-5">Submit Loan Application Request</h2>
      <SubmitLoanApplication {...props} />
    </>}
  </div>
}

export default SubmitApplication